import { BufferImageSource, Texture } from "pixi.js";
import { generateNoiseData, mudZone, NOISE_SIZE } from "./warNoiseData";

// (0.98.8: the bytes and the lookups are in warNoiseData.ts, without Pixi, for the bakes' worker; passed on from here)
export { mudZone, sampleNoise } from "./warNoiseData";

/**
 * The mud regions of a whole map as a small texture (one texel per `cell` game units), computed with
 * mudZone() on the CPU, so the ground shader and the decal placement use exactly the same values.
 */
export function createZoneTexture(width: number, height: number, cell = 4): Texture {
    const cols = Math.max(1, Math.ceil(width / cell)), rows = Math.max(1, Math.ceil(height / cell));
    const data = new Uint8Array(cols * rows * 4);
    for (let y = 0; y < rows; y++) {
        for (let x = 0; x < cols; x++) {
            const v = Math.round(mudZone((x + 0.5) * width / cols, (y + 0.5) * height / rows) * 255);
            const i = (y * cols + x) * 4;
            data[i] = data[i + 1] = data[i + 2] = v; data[i + 3] = 255;
        }
    }
    const source = new BufferImageSource({ resource: data, width: cols, height: rows, scaleMode: "linear", alphaMode: "no-premultiply-alpha" });
    return new Texture({ source });
}

/**
 * the noise as a texture (`mipmaps` off for a shader that reads it in polar coordinates: where the angle wraps, the
 * jump in the lookup picks the smallest mipmap and draws a seam, 0.98.5's tornado funnel)
 */
export function createNoiseTexture(mipmaps = true): Texture {
    const data = generateNoiseData();
    // raw bytes (not a canvas): the alpha channel carries data and must not be premultiplied
    const source = new BufferImageSource({
        resource: data,
        width: NOISE_SIZE,
        height: NOISE_SIZE,
        addressMode: "repeat",
        scaleMode: "linear",
        autoGenerateMipmaps: mipmaps,
        alphaMode: "no-premultiply-alpha"
    });
    if (mipmaps) source.updateMipmaps?.();
    return new Texture({ source });
}
